import { Injectable } from '@angular/core';
import { State, Action, StateContext } from '@ngxs/store';
import { TaskStatusActions } from './task-status.actions';
import { AlertService } from '../alert/alert.service';
import { LocalizationService } from 'src/app/services/localization/localization.service';
import { TaskStatusService } from '../../services/task-status.service';
import { TaskStatus } from '../../models/task-status.model';
import { error } from '@rxweb/reactive-form-validators';
import { MappingUtilsService } from 'src/app/services/utils/mapping-utils.service';

export class TaskStatusStateModel {
  public taskStatus: TaskStatus[];
  public error: string;
}

const defaults = {
  taskStatus: [],
  error: ''
};

@State<TaskStatusStateModel>({
  name: 'taskStatus',
  defaults
})
@Injectable()
export class TaskStatusState {

  constructor(
    private alertService: AlertService,
    private localizationService: LocalizationService,
    private taskStatusService: TaskStatusService
  ) { }

  @Action(TaskStatusActions.GetTaskStatus)
  getTaskStatus(ctx: StateContext<TaskStatusStateModel>, { }: TaskStatusActions.GetTaskStatus) {
    return this.taskStatusService.getTaskStatus().subscribe({
      next: (taskStatus: TaskStatus[]) => {
        ctx.dispatch(new TaskStatusActions.GetTaskStatusSuccess(taskStatus));
      },
      error: (error) => {
        ctx.dispatch(new TaskStatusActions.GetTaskStatusFail(error));
      }
    });
  }

  @Action(TaskStatusActions.GetTaskStatusSuccess)
  getTaskStatusSuccess(ctx: StateContext<TaskStatusStateModel>, { taskStatus }: TaskStatusActions.GetTaskStatusSuccess) {
    ctx.patchState({
      taskStatus: taskStatus
    });
  }

  @Action(TaskStatusActions.GetTaskStatusFail)
  getTaskStatusFail(ctx: StateContext<TaskStatusStateModel>, { error }: TaskStatusActions.GetTaskStatusFail) {
    ctx.patchState({
      error: error,
    });
    MappingUtilsService.showError(this.getTitle(), error, this.alertService, this.localizationService);
  }

  private getTitle() {
    return this.localizationService.translate('task-status.title');
  }
}
